export function useDevice() {
  const isDesktop = useMediaQuery('(min-width: 1024px)', {
    ssrWidth: 400
  })

  return { isDesktop };
}